"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[740],{

/***/ 3003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Page; },
/* harmony export */   "getPageById": function() { return /* binding */ getPageById; },
/* harmony export */   "getStaticPaths": function() { return /* binding */ getStaticPaths; },
/* harmony export */   "getStaticProps": function() { return /* binding */ getStaticProps; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7568);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9113);
/* harmony import */ var _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(315);
/* harmony import */ var _builder_io_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5102);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2991);
/* harmony import */ var _components_meta_block_MetaBlock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8962);
/* harmony import */ var _components_not_found_not_found__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(797);
/* harmony import */ var _contexts_ThemeContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3840);
/* harmony import */ var _models_PageModel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(5731);
/* harmony import */ var _types_builder_d__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9209);
/* harmony import */ var _utils_Builder__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(8332);
/* provided dependency */ var process = __webpack_require__(8584);











function getStaticProps(_) {
    return _getStaticProps.apply(this, arguments);
}
function _getStaticProps() {
    _getStaticProps = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var params, slug, pageSlug, page;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    params = param.params;
                    slug = params.slug;
                    pageSlug = Array.isArray(slug) ? slug.join("/") : slug;
                    _ctx.next = 5;
                    return _models_PageModel__WEBPACK_IMPORTED_MODULE_7__/* ["default"].findPage */ .Z.findPage({
                        params: {
                            url: pageSlug
                        },
                        includeUnpublished: true
                    });
                case 5:
                    page = _ctx.sent;
                    if (page) {
                        _ctx.next = 8;
                        break;
                    }
                    return _ctx.abrupt("return", /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_not_found_not_found__WEBPACK_IMPORTED_MODULE_5__["default"], {}));
                case 8:
                    return _ctx.abrupt("return", {
                        props: {
                            page: page
                        },
                        revalidate: 5
                    });
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getStaticProps.apply(this, arguments);
}
function getStaticPaths() {
    return _getStaticPaths.apply(this, arguments);
}
function _getStaticPaths() {
    _getStaticPaths = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var pages, paths;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return _models_PageModel__WEBPACK_IMPORTED_MODULE_7__/* ["default"].getAllPage */ .Z.getAllPage(false, false, "data.url");
                case 2:
                    pages = _ctx.sent;
                    paths = pages.map(function(page) {
                        return _models_PageModel__WEBPACK_IMPORTED_MODULE_7__/* ["default"].convertBuilderURL2Slug */ .Z.convertBuilderURL2Slug(page.data.url);
                    });
                    return _ctx.abrupt("return", {
                        paths: paths,
                        fallback: true
                    });
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getStaticPaths.apply(this, arguments);
}
var getPageById = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(_vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(pageId, cb) {
        var page;
        return _vercel_path0_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    if (pageId) {
                        _ctx.next = 2;
                        break;
                    }
                    return _ctx.abrupt("return");
                case 2:
                    _ctx.next = 4;
                    return _models_PageModel__WEBPACK_IMPORTED_MODULE_7__/* ["default"].findPage */ .Z.findPage({
                        params: {
                            modelId: Array.isArray(pageId) ? pageId[0] : pageId
                        }
                    });
                case 4:
                    page = _ctx.sent;
                    cb === null || cb === void 0 ? void 0 : cb(page);
                    return _ctx.abrupt("return", page);
                case 7:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function getPageById(pageId, cb) {
        return _ref.apply(this, arguments);
    };
}();
function Page(props) {
    var ref, ref1, ref2;
    var page = props.page;
    var theme = (0,_contexts_ThemeContext__WEBPACK_IMPORTED_MODULE_6__/* .useThemeContext */ .TC)();
    var canonicalSlug = _models_PageModel__WEBPACK_IMPORTED_MODULE_7__/* ["default"].convertBuilderURL2Slug */ .Z.convertBuilderURL2Slug(page === null || page === void 0 ? void 0 : (ref = page.data) === null || ref === void 0 ? void 0 : ref.url);
    if (canonicalSlug === "/home") {
        canonicalSlug = "/";
    }
    var canonicalUrl = process.env.SITE_URL || "https://www.roomstay.io" + canonicalSlug;
    var renderContent = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_builder_io_react__WEBPACK_IMPORTED_MODULE_2__/* .BuilderComponent */ .VD, {
            model: _types_builder_d__WEBPACK_IMPORTED_MODULE_8__/* .BUILDER_MODEL.PAGE */ .A.PAGE,
            content: page,
            data: (0,_utils_Builder__WEBPACK_IMPORTED_MODULE_9__/* .getBlockDataMap */ .LV)(page)
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        theme.setThemeStyle(page.data.layout);
        if (page.data.layout === _contexts_ThemeContext__WEBPACK_IMPORTED_MODULE_6__/* .ThemeStyles.Blog */ .Cz.Blog && page.data.theme) {
            theme.setArticleTheme(page.data.theme);
        } else {
            theme.setArticleTheme(null);
        }
        if (page.data.hideDefaultFooter) {
            theme.setShowBookDemoFooter(false);
        }
        return function() {
            theme.setArticleTheme(null);
            theme.setShowBookDemoFooter(true);
        };
    }, [
        page,
        theme
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_meta_block_MetaBlock__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                title: page === null || page === void 0 ? void 0 : (ref1 = page.data) === null || ref1 === void 0 ? void 0 : ref1.title,
                description: page === null || page === void 0 ? void 0 : (ref2 = page.data) === null || ref2 === void 0 ? void 0 : ref2.description,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
                    rel: "canonical",
                    href: canonicalUrl
                })
            }),
            renderContent()
        ]
    });
};


/***/ })

}]);